export default {
    debounce(handle, delay) {
        let time = null;
        return function () {
            let self = this,
                arg = arguments;
            clearTimeout(time);
            time = setTimeout(function () {
                handle.apply(self, arg);
            }, delay)
        }
    },

    checkAuth(rule){
        if(rule){
            var nodes = localStorage.getItem('nodes');
            if(nodes){
                nodes = JSON.parse(nodes);
                if(nodes && nodes.includes(rule)){
                    return true;
                }
            }
        }
        return false;
    },

    imgDomain(src, baseURL){
        return (src && (typeof src === 'string')) ? ((src.indexOf('http') != -1 ? '' : baseURL) + src) : '';
    },

    dealImg(imgStr, BASE_URL) {
        var newStr = imgStr.indexOf("http");
        if (newStr == -1) {
            imgStr = BASE_URL + imgStr.replaceAll('\\', '/')
        } else {
            imgStr = imgStr.replaceAll('https', 'http')
            imgStr = imgStr.replaceAll('http', 'https')
        }
        return imgStr
    },

    float2(value){
        return value.toString().replace(/[^\d^\.]+/g, '').replace(/^0+(\d)/, '$1').replace(/^\./, '0.').match(/^\d*(\.?\d{0,2})/g)[0] || '';
    },

    openwin(url){
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
    },

    /**
     * 导出数据为CSV文件
     * @param {Array} headers - 表头数组
     * @param {Array} data - 数据数组（二维数组）
     * @param {String} fileName - 文件名（可选）
     */
    exportToCSV(headers, data, fileName = '') {
        if (!headers || !Array.isArray(headers) || headers.length === 0) {
            console.error('表头不能为空');
            return false;
        }
        
        if (!data || !Array.isArray(data) || data.length === 0) {
            console.error('数据不能为空');
            return false;
        }

        // 生成CSV内容
        const csvContent = this.generateCSV(headers, data);
        
        // 创建下载链接
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        // 生成文件名
        const finalFileName = fileName || `导出数据_${new Date().toLocaleDateString()}.csv`;
        
        link.setAttribute('href', url);
        link.setAttribute('download', finalFileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        return true;
    },

    /**
     * 将对象数组转换为CSV导出格式
     * @param {Array} objectArray - 对象数组
     * @param {Array} fieldMapping - 字段映射数组，格式：[{key: '字段名', label: '表头名'}]
     * @param {String} fileName - 文件名（可选）
     */
    exportObjectArrayToCSV(objectArray, fieldMapping, fileName = '') {
        if (!objectArray || !Array.isArray(objectArray) || objectArray.length === 0) {
            console.error('数据不能为空');
            return false;
        }

        if (!fieldMapping || !Array.isArray(fieldMapping) || fieldMapping.length === 0) {
            console.error('字段映射不能为空');
            return false;
        }

        // 生成表头
        const headers = fieldMapping.map(item => item.label);
        
        // 生成数据
        const data = objectArray.map(obj => {
            return fieldMapping.map(mapping => {
                const value = obj[mapping.key];
                return value !== undefined && value !== null ? value : '';
            });
        });

        return this.exportToCSV(headers, data, fileName);
    },

    /**
     * 生成CSV格式内容
     * @param {Array} headers - 表头数组
     * @param {Array} data - 数据数组（二维数组）
     * @returns {String} CSV格式的字符串
     */
    generateCSV(headers, data) {
        // 处理表头
        const csvHeaders = headers.map(header => {
            // 如果包含逗号、引号或换行符，需要用引号包围并转义内部引号
            if (header.includes(',') || header.includes('"') || header.includes('\n')) {
                return `"${header.replace(/"/g, '""')}"`;
            }
            return header;
        }).join(',');

        // 处理数据行
        const csvRows = data.map(row => {
            return row.map(field => {
                // 转换为字符串并处理特殊字符
                const fieldValue = String(field || '');
                // 如果包含逗号、引号或换行符，需要用引号包围并转义内部引号
                if (fieldValue.includes(',') || fieldValue.includes('"') || fieldValue.includes('\n')) {
                    return `"${fieldValue.replace(/"/g, '""')}"`;
                }
                return fieldValue;
            }).join(',');
        });

        return [csvHeaders, ...csvRows].join('\n');
    },

    printer(imgs, baseURL) {
        return new Promise((resolve, reject) => {
            if (!imgs || !Array.isArray(imgs) || imgs.length === 0) {
                const errorMsg = '面单图片路径为空';
                this.$message.warning(errorMsg);
                return reject(new Error(errorMsg));
            }

            const iframe = document.createElement('iframe');
            iframe.style.cssText = 'position:absolute;width:0;height:0;left:-9999px;';
            document.body.appendChild(iframe);

            imgs = imgs.map(img => this.imgDomain(img, baseURL));
            console.log('打印图片地址:', imgs);

            const imgsPromises = imgs.map(img => {
                return new Promise((resolveImg, rejectImg) => {
                    const tempImg = new Image();
                    tempImg.onload = () => resolveImg(tempImg);
                    tempImg.onerror = () => rejectImg(new Error(`图片加载失败: ${img}`));
                    tempImg.src = img;
                });
            });

            Promise.all(imgsPromises).then(tempImgs => {
                let printContent = tempImgs
                    .map(img => `
                        <div style="text-align: center; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                            <img src="${img.src}" style="width: 100%; max-width: 100%;">
                        </div>
                    `)
                    .join('');
                console.log('打印内容：', printContent);

                iframe.contentDocument.open();
                iframe.contentDocument.write(`
                    <!DOCTYPE html>
                    <html style="width: 100%; height: 100%;">
                    <head>
                        <meta charset="utf-8">
                        <style>
                            @media print {
                                * { -webkit-print-color-adjust: exact !important; color-adjust: exact !important; }
                                body { margin: 0 !important; padding: 0 !important; width: 100% !important; height: 100% !important; }
                            }
                            @page { size: auto; margin: 0mm !important; padding: 0mm !important; }
                            html, body { width: 100%; height: 100%; margin: 0; padding: 0; }
                        </style>
                    </head>
                    <body>${printContent}</body>
                    </html>
                `);
                iframe.contentDocument.close();
                iframe.onload = () => {
                    try {
                        setTimeout(() => {
                            console.log('开始打印');
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();

                            // 成功后移除 iframe 并 resolve
                            setTimeout(() => {
                                console.log('打印成功');
                                if (document.body.contains(iframe)) {
                                    document.body.removeChild(iframe);
                                }
                                resolve('打印成功');
                            }, 2000);
                        }, 500);
                    } catch (error) {
                        console.error('打印失败:', error);
                        reject(new Error('打印失败，请稍后重试'));
                    }
                };
            }).catch(error => {
                console.error('打印失败:', error);
                this.$alert(`面单图片加载失败: ${error.message}`, '面单打印错误', {
                    dangerouslyUseHTMLString: true,
                    type: 'error',
                    callback: action => {}
                });
                if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                }
                reject(error);
            });
        });
    },
}


// WEBPACK FOOTER //
// ./src/utils/index.js